module.exports = __webpack_public_path__ + "img/hzfp37.598dc385.png";